import { render, staticRenderFns } from "./CampaignPopup.vue?vue&type=template&id=218a6f18&scoped=true"
import script from "./CampaignPopup.vue?vue&type=script&lang=ts"
export * from "./CampaignPopup.vue?vue&type=script&lang=ts"
import style0 from "./CampaignPopup.vue?vue&type=style&index=0&id=218a6f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a6f18",
  null
  
)

export default component.exports